import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'con-icon-by-name',
  templateUrl: './icon-by-name.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class IconByNameComponent {
  @Input() iconName: string;
  @Input() mutations: any = [];

  getClasses() {
    let str = 'fa-' + this.iconName;
    this.mutations.forEach((mutation) => {
      str += ' fa-' + mutation;
    });
    return str;
  }
}
